export default __webpack_public_path__ + "static/media/4745.334ddae0.webp";